import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: "What if my partner won't cooperate?",
  a: "The system includes copy-paste texts specifically designed to start this conversation without triggering defensiveness. You don't pitch it as 'I need help' — you pitch it as 'I found a system, can we try it for 3 nights?' Most partners who resist 'asking for help' will try a defined system. The ON/OFF card removes the need to negotiate in the moment."
}, {
  q: "I'm breastfeeding. Can I still use this?",
  a: 'Yes — one of the 4 shift models is specifically designed for breastfeeding parents. It protects your longest sleep window while keeping you available for feeds. The system works around your feeding schedule, not against it.'
}, {
  q: 'Is this just a PDF? What am I actually getting?',
  a: "It's a short, printable system — not a long ebook you'll never finish. You get the shift models, the handoff scripts, the anti-resentment rules, the weekly planner, and the fridge card. Everything is designed to be used the same night you download it. No reading required beyond what you need."
}, {
  q: "Our baby's schedule changes every week. Will this still work?",
  a: "That's exactly what the Plan B protocol is for. The system doesn't depend on your baby sleeping on a schedule — it depends on YOU having a defined block. The weekly planner lets you adjust every 7 days based on what's actually happening."
}, {
  q: "What if it doesn't work for us?",
  a: "If you run the system for 3 nights and feel it didn't help, reach out. For $6.36, we'd rather you feel good about the purchase than not. The goal is a workable night — not a perfect one."
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="py-20 px-5 max-w-2xl mx-auto" data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-49">
        <h2 className="font-serif text-3xl text-gold-400 mb-10 text-center" data-id="element-50">
          Questions you're probably thinking
        </h2>

        <div className="space-y-3" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="border border-white/8 rounded-xl overflow-hidden bg-[#1a2540]/60" data-id="element-52">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-start justify-between gap-4 p-5 text-left" data-id="element-53">
                <span className="text-cream-50 font-medium text-sm sm:text-base leading-snug" data-id="element-54">
                  {faq.q}
                </span>
                <span className="text-gold-400 flex-shrink-0 mt-0.5" data-id="element-55">
                  {open === i ? <Minus className="w-4 h-4" data-id="element-56" /> : <Plus className="w-4 h-4" data-id="element-57" />}
                </span>
              </button>

              <AnimatePresence initial={false} data-id="element-58">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-59">
                    <p className="px-5 pb-5 text-cream-100/70 text-sm leading-relaxed border-t border-white/5 pt-4" data-id="element-60">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </motion.div>
    </section>;
}